import { queryStringBuilder } from 'Shared/Utils/queryStringBuilder';
import { AxiosResponse } from 'axios';

import { apiInstanceType, onErrorType, onResultType, requestConfigType } from '../Contracts/types';
import { ShowResponseError } from '../Utils/showResponseError';

export interface IHttpDeleteServiceProps {
  url: string;
  body?: object;
  onResult?: onResultType;
  onError?: onErrorType;
  config?: requestConfigType;
  fromQuery?: boolean;
}

interface IProps extends IHttpDeleteServiceProps {
  API: apiInstanceType;
}

export const HttpDeleteService = async (props: IProps) => {
  if (props.onResult === undefined) {
    props.onResult = (res: AxiosResponse<any, any>): any => {
      if (res.status === 201 || res.status === 200) {
        return res.data;
      }
    };
  }
  if (props.onError === undefined) {
    props.onError = (error: any) => {
      ShowResponseError(error);
    };
  }

  try {
    if (props.fromQuery == undefined || props.fromQuery == true) {
      const data: string = props.body !== undefined && props.body !== null ? '?' + queryStringBuilder(props.body) : '';
      const response = await props.API.delete(props.url + data)
        .then(props.onResult)
        .catch(props.onError);

      return response;
    } else {
      const response = await props.API.delete(props.url, {
        data: {
          ...(props.body !== undefined && props.body !== null && props.body),
        },
      })
        .then(props.onResult)
        .catch(props.onError);

      return response;
    }
  } catch (error) {
    ShowResponseError(error);
  }
};

export default HttpDeleteService;
